class DaysServices {
  static getDayStart = (date) => {
    const startOfDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0,
      0
    );

    return startOfDay;
  };
  static getDayEnd = (date) => {
    const endOfDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59,
      999
    );

    return endOfDay;
  };

  static setDateTime = (date, time) => {
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

    if (timeRegex.test(time)) {
      const [hours, minutes, seconds] = time.split(":").map(Number);
      date.setHours(hours, minutes, seconds, 0);
    } else {
      date.setHours(0, 0, 0, 0);
    }

    return date;
  };
}

export default DaysServices;
